module.exports = __webpack_public_path__ + "static/media/load-notificaciones.833408f6.svg";